import React from "react";
import { ProgressSpinner } from "primereact/progressspinner";

export default function ProgressSpinnerPR() {
  return <ProgressSpinner />;
}
